import React from 'react';
import classnames from 'classnames';
import SimpleButton from 'components/controls/buttons/SimpleButton';

import styles from './Button.scss';
import mergeStyles from 'components/helpers/mergeStyles';
import IconButton from 'components/controls/buttons/IconButton';
import {noop} from 'components/helpers/funcTools';

const PRIMARY = 'primary';
const SECONDARY = 'secondary';
const TERTIARY = 'tertiary';

export const BUTTON_COLORS = [PRIMARY, SECONDARY, TERTIARY];

export default function Button({
    classes,
    color,
    label,
    Icon,
    onIconClick = noop,
    disabled,
    variant = "contained",
    ...props
}) {

    return (
        <SimpleButton
            classes={
                mergeStyles(
                    {
                        root: classnames(
                            styles.root,
                            styles.primary,
                            {
                                [styles.secondary]: color === SECONDARY,
                                [styles.tertiary]: color === TERTIARY,
                                [styles.disabled]: disabled,
                            },
                        ),
                        outlined: styles.outlined,
                        label: classnames(styles.label, {[styles.tertiaryLabel]: color === TERTIARY}),
                        containedPrimary: styles.primary,
                        containedSecondary: styles.secondary,
                        sizeSmall: styles.small,
                        sizeLarge: styles.large,
                    },
                    classes,
                )}
            variant={variant}
            disableElevation
            disabled={disabled}
            {...props}
        >
            {label}
            {Icon && (
                <IconButton
                    onClick={onIconClick}
                    Icon={Icon}
                />
            )}
        </SimpleButton>
    )
}

Button.propTypes = {

}



// WEBPACK FOOTER //
// ./src/components/controls/buttons/Button.jsx